export default {"src":"/_next/static/media/boysenberries.59fadbba.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};